export enum ApplicationType {
    TaxprepT1 = 1,
    TaxprepT2 = 2,
    TaxprepT3 = 3,
    TaxprepForms = 4,
    iFirmTaxT1 = 11,
    iFirmTaxT2 = 12,
    iFirmTaxT3 = 13,
    iFirmTaxForms = 14,
    JobsBilling = 20,
}

export type Product = "T1" | "T2" | "T3" | "Forms" | "Jobs & Billing" | "UNKNOWN";

export function productStringFromApplicationType(applicationType: ApplicationType): Product {
    switch (applicationType) {
        case ApplicationType.TaxprepT1:
        case ApplicationType.iFirmTaxT1:
            return "T1";
        case ApplicationType.TaxprepT2:
        case ApplicationType.iFirmTaxT2:
            return "T2";
        case ApplicationType.TaxprepT3:
        case ApplicationType.iFirmTaxT3:
            return "T3";
        case ApplicationType.TaxprepForms:
        case ApplicationType.iFirmTaxForms:
            return "Forms";
        case ApplicationType.JobsBilling:
            return "Jobs & Billing";
        default:
            return "UNKNOWN";
    }
}

export type ApplicationName = "Taxprep" | "iFirm Taxprep" | "Jobs & Billing" | "UNKNOWN";

export function applicationStringFromApplicationType(applicationType: ApplicationType): ApplicationName {
    switch (applicationType) {
        case ApplicationType.TaxprepT1:
        case ApplicationType.TaxprepT2:
        case ApplicationType.TaxprepT3:
        case ApplicationType.TaxprepForms:
            return "Taxprep";
        case ApplicationType.iFirmTaxT1:
        case ApplicationType.iFirmTaxT2:
        case ApplicationType.iFirmTaxT3:
        case ApplicationType.iFirmTaxForms:
            return "iFirm Taxprep";
        case ApplicationType.JobsBilling:
            return "Jobs & Billing";
        default:
            return "UNKNOWN";
    }
}

export type ApplicationTag = "Taxprep" | "iFirmTax" | "Jobs&Billing" | "UNKNOWN";

export function applicationTagFromApplicationType(applicationType: ApplicationType): ApplicationTag {
    switch (applicationType) {
        case ApplicationType.TaxprepT1:
        case ApplicationType.TaxprepT2:
        case ApplicationType.TaxprepT3:
        case ApplicationType.TaxprepForms:
            return "Taxprep";
        case ApplicationType.iFirmTaxT1:
        case ApplicationType.iFirmTaxT2:
        case ApplicationType.iFirmTaxT3:
        case ApplicationType.iFirmTaxForms:
            return "iFirmTax";
        case ApplicationType.JobsBilling:
            return "Jobs&Billing";
        default:
            return "UNKNOWN";
    }
}

export function isTaxprep(applicationType: ApplicationType | undefined): boolean {
    switch (applicationType) {
        case ApplicationType.TaxprepT1:
        case ApplicationType.TaxprepT2:
        case ApplicationType.TaxprepT3:
        case ApplicationType.TaxprepForms:
            return true;
        default:
            return false;
    }
}

export function isiFirmTax(applicationType: ApplicationType | undefined): boolean {
    switch (applicationType) {
        case ApplicationType.iFirmTaxT1:
        case ApplicationType.iFirmTaxT2:
        case ApplicationType.iFirmTaxT3:
        case ApplicationType.iFirmTaxForms:
            return true;
        default:
            return false;
    }
}

export function isJobsBilling(applicationType: ApplicationType | undefined): boolean {
    return applicationType === ApplicationType.JobsBilling;
}
